import ModalGlobal from "../modalGlobalTopbar/ModalGlobalTopbar";
import style from "./ModalMensagem.module.css";
import NotificacaoApi from "../../../services/NotificacaoApi";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { LuListCheck } from "react-icons/lu";

function ModalMensagem({ mostrar, aoFechar, botaoRef }) {
  const [notificacoes, setNotificacoes] = useState([]);
  const navigate = useNavigate();

  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });

  // Função para calcular a posição do modal
  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      setPosicao({
        top: rect.bottom + 8, // 5px de margem abaixo do botão
        left: rect.right - 375, // Ajusta para alinhar à direita do botão
      });
    }
  };

  useEffect(() => {
    if (mostrar) {
      calcularPosicao(); // Atualiza a posição ao abrir

      // Atualiza a posição ao redimensionar a janela
      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]); // Recalcula sempre que o modal for mostrado

  async function mostrarNotificacoes() {
    try {
      const notificacao =
        await NotificacaoApi.ListarNotificacoesPorUsuarioIdAsync();
      setNotificacoes(notificacao);
    } catch (error) {
      console.error("Erro ao listar notificações:", error.response.data);
    }
  }

  useEffect(() => {
    mostrarNotificacoes();
  }, []);

  return (
    <ModalGlobal mostrar={mostrar} aoFechar={aoFechar}>
      <div
        ref={modalRef}
        className={style.container_modal}
        style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
      >
        <div className={style.header_notificacao}>
          <h5>Mensagens</h5>
          <Link
            className={style.icone_header}
            to="/notificacoes"
            title="Ver todas notificações"
          >
            <LuListCheck />
          </Link>
        </div>
        <div className={style.notificacao}>
          {notificacoes.map((notificacao) => (
            <Link
              to="/notificacoes"
              state={notificacao.notificacaoId}
              key={notificacao.notificacaoId}
              className={`${style.container_notificacao} ${
                !notificacao.lido ? style.notificacaoLida : ""
              }`}
            >
              <div className={style.conteudo_notificacao}>
                <IoIosNotifications id={style.icone_notificacao} />
                <h6 id={style.titulo_notificacao}>{notificacao.titulo}</h6>
              </div>
              <div className={style.corpo_notificacao}>
                <p>{new Date(notificacao.dataEnvio).toLocaleString("pt-BR")}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </ModalGlobal>
  );
}

export default ModalMensagem;
